import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Company } from '../../models/company.model';
import { AccountingAccount } from '../../models/accounting.account.model';
import { formatAccountingAccount } from '../../scripts/format.value.script';

export interface AppInputAccountingAccountTaxProps {
  companyForUser: Company,
  accountingTaxAccountsForCompany: AccountingAccount[],
  indexContent: number,
  contentTaxAccounts: {value: {content_id: string, accounting_account_tax: string, object: any}[], valid: boolean[]},
  setContentTaxAccounts: Dispatch<SetStateAction<{value: {content_id: string, accounting_account_tax: string, object: any}[], valid: boolean[]}>>,
};

const AppInputAccountingAccountTax: React.FunctionComponent<AppInputAccountingAccountTaxProps> = ({companyForUser, accountingTaxAccountsForCompany, indexContent, contentTaxAccounts, setContentTaxAccounts}) => {
  const {lang} = StateLanguage()

  const handleChangeAccountingAccount = (item: AccountingAccount) => {
    let tempContentTaxAccountsValue = contentTaxAccounts.value.map((temp_item, temp_index) => {
      if (indexContent === temp_index) {
        temp_item.accounting_account_tax = item.id
        temp_item.object = item
      }
      return temp_item
    })
    let tempContentTaxAccountsValid = contentTaxAccounts.valid.map((temp_item, temp_index) => {
      if (indexContent === temp_index) {
        temp_item = true
      }
      return temp_item
    })

    setContentTaxAccounts({value: tempContentTaxAccountsValue, valid: tempContentTaxAccountsValid})
  }

  return (
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-350px p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select form-select-sm">
              <span className="select2-selection__rendered" role="textbox">
                {contentTaxAccounts.valid[indexContent] ? formatAccountingAccount(contentTaxAccounts.value[indexContent].object, companyForUser?.language ?? 'fr') : lang.labels.selectOption}
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open" renderOnMount popperConfig={{ strategy: 'fixed', modifiers: [{ name: 'sameWidth', enabled: true, phase: 'beforeWrite' as const, requires: ['computeStyles'], fn: ({ state }: any) => { state.styles.popper.width = `${state.rects.reference.width}px` }, effect: ({ state }: any) => { state.elements.popper.style.width = `${(state.elements.reference as HTMLElement).offsetWidth}px` } }] }}>
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox" style={{maxHeight: '300px', overflowY: 'auto'}}>
                { (accountingTaxAccountsForCompany ?? []).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === contentTaxAccounts.value[indexContent].accounting_account_tax && "select2-results__option--selected"}`} role="option" aria-selected={item.id === contentTaxAccounts.value[indexContent].accounting_account_tax}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeAccountingAccount(item)}>{formatAccountingAccount(item, companyForUser?.language ?? 'fr')}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
  )
}

export default AppInputAccountingAccountTax;
